module.exports = __webpack_public_path__ + "img/img_open_box.7707d0b5.png";